import { Form, Spin, Upload } from 'antd'
import { InboxOutlined } from '@ant-design/icons'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { actions } from '../../../../../../../../store/reducers/assignments.reducer'

const { Dragger } = Upload

const UploadAnswerKey = ({ getExcelSheets, moveToNextStep }) => {
    const [isWaitingForUpload, setIsWaitingForUpload] = useState(false)

    const onUpload = async file => {
        setIsWaitingForUpload(true)
        const sheets = await getExcelSheets(file)
        setIsWaitingForUpload(false)
        if (sheets) moveToNextStep()
        return false
    }

    const draggerProps = {
        name: 'file',
        accept: '.xlsx',
        listType: 'picture',
        maxCount: 1,
        fileList: [],
        beforeUpload: onUpload,
    }

    return (
        <Spin spinning={isWaitingForUpload}>
            <Form name='upload-answer-key' autoComplete='off'>
                <Form.Item>
                    <Dragger {...draggerProps} aria-label='Answer key'>
                        <p className='ant-upload-drag-icon'>
                            <InboxOutlined />
                        </p>
                        <p className='ant-upload-text'>Click or drag spreadsheet answer key file to this area</p>
                    </Dragger>
                </Form.Item>
            </Form>
        </Spin>
    )
}

const mapDispatch = dispatch => {
    return {
        getExcelSheets(value) {
            return dispatch(actions.getExcelSheets(value))
        },
    }
}

export default connect(null, mapDispatch)(UploadAnswerKey)
